import React, { useState, useRef } from 'react';
import { FaYoutube, FaTwitter, FaLinkedin, FaGithub, FaGraduationCap, FaBriefcase, FaInfinity } from 'react-icons/fa';
import { SiDocker, SiKubernetes, SiAmazon, SiTerraform, SiJavascript, SiGnubash, SiGit, SiGithubactions } from 'react-icons/si';

function About() {
  const [submitted, setSubmitted] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const iframeRef = useRef(null);

  const handleSubmit = () => {
    setSubmitted(true);
  };

  const handleIframeLoad = () => {
    if (submitted) {
      setShowDialog(true);
      setSubmitted(false);
    }
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    window.location.href = '/';
  };

  const techStack = [
    { icon: SiKubernetes, name: "Kubernetes", color: "text-blue-600" },
    { icon: SiDocker, name: "Docker", color: "text-blue-500" },
    { icon: SiAmazon, name: "AWS", color: "text-yellow-600" },
    { icon: SiTerraform, name: "Terraform", color: "text-purple-600" },
    { icon: SiGithubactions, name: "GitHub Actions", color: "text-blue-500" },
    { icon: SiJavascript, name: "JavaScript", color: "text-yellow-500" },
    { icon: SiGnubash, name: "Bash", color: "text-gray-700" },
    { icon: SiGit, name: "Git", color: "text-orange-600" },
  ];

  const timeline = [
    {
      year: "2024 - Present",
      title: "DevOps Specialist at Midships",
      description: "DevOps Specialist for IAM and Security applications.",
      icon: FaInfinity,
      type: "work",
      photos: ["/images/midshipsAward.jpg"]
    },
    {
      year: "2023 - Present",
      title: "Content Creator",
      description: "Started YouTube channel @mayanksonidev to share DevOps knowledge.",
      icon: FaYoutube,
      type: "work",
      photos: ["/images/youtubeScreenshot.png"]
    },
    {
      year: "2022 - 2024",
      title: "DevOps Engineer at Ivanti",
      description: "DevOps Engineer for ITSM and UEM applications.",
      icon: FaBriefcase,
      type: "work",
      photos: ["/images/ivantiAward.jpeg"]
    },
    {
      year: "2019 - 2022",
      title: "SDE at HCLTech",
      description: "Software Developer for Build and Release Management Tool.",
      icon: FaBriefcase,
      type: "work",
      photos: ["/images/hclAward.jpeg"]
    },
    {
      year: "2015 - 2019",
      title: "IIT Delhi",
      description: "Bachelor of Technology. Focused on Computer Science fundamentals and engineering.",
      icon: FaGraduationCap,
      type: "education",
      photos: []
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-5xl mx-auto space-y-16">

        {/* HERO SECTION */}
        <div className="bg-white shadow-xl rounded-3xl overflow-hidden transform hover:scale-[1.01] transition-all duration-300">
          <div className="md:flex">
            <div className="md:w-1/2 p-10 flex flex-col justify-center bg-gradient-to-br from-blue-600 to-indigo-800 text-white">
              <h1 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight">
                Hello, I'm <br />
                <span className="text-blue-200">Mayank Soni</span>
              </h1>
              <p className="text-lg text-blue-100 mb-8 leading-relaxed">
                DevOps Engineer from IIT Delhi with a passion for cloud native technologies and content creation.
              </p>
              <div className="flex space-x-4">
                <a href="https://twitter.com/mayanksonidev" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 rounded-full hover:bg-white/20 transition-all backdrop-blur-sm">
                  <FaTwitter className="h-6 w-6" />
                </a>
                <a href="https://www.linkedin.com/in/mayank-soni121" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 rounded-full hover:bg-white/20 transition-all backdrop-blur-sm">
                  <FaLinkedin className="h-6 w-6" />
                </a>
                <a href="https://youtube.com/@mayanksonidev" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 rounded-full hover:bg-white/20 transition-all backdrop-blur-sm">
                  <FaYoutube className="h-6 w-6" />
                </a>
                <a href="https://github.com/mayanksoni121" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 rounded-full hover:bg-white/20 transition-all backdrop-blur-sm">
                  <FaGithub className="h-6 w-6" />
                </a>
              </div>
            </div>
            <div className="md:w-1/2 relative min-h-[300px] md:min-h-full">
              <img
                src="/images/avatar.jpg"
                alt="Mayank Soni"
                className="w-full h-full object-cover absolute inset-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent md:hidden"></div>
            </div>
          </div>
        </div>

        {/* TECH STACK */}
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-10">My Toolbox</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {techStack.map((tech, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 flex flex-col items-center justify-center border border-gray-100 group">
                <tech.icon className={`h-12 w-12 ${tech.color} mb-4 group-hover:scale-110 transition-transform`} />
                <span className="font-semibold text-gray-700">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* TIMELINE */}
        <div className="bg-white shadow-lg rounded-3xl p-8 md:p-12 border border-gray-100">
          <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">My Journey</h2>
          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gray-300 before:to-transparent">
            {timeline.map((item, index) => (
              <div key={index} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-blue-500 shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10 transition-transform group-hover:scale-110">
                  <item.icon className="text-white w-5 h-5" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center justify-between space-x-2 mb-1">
                    <div className="font-bold text-gray-900">{item.title}</div>
                    <time className="font-caveat font-medium text-blue-600">{item.year}</time>
                  </div>
                  <div className="text-slate-500">{item.description}</div>
                </div>

                {/* Photos Logic */}
                <div className={`hidden md:flex w-[calc(50%-2.5rem)] md:order-2 gap-2 items-center ${index % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
                  {item.photos && item.photos.length > 0 ? (
                    item.photos.map((photo, pIndex) => (
                      <div key={pIndex} className="relative w-30 h-24 group/photo hover:z-50">
                        <img
                          src={photo}
                          alt={`${item.title} ${pIndex + 1}`}
                          className="w-full h-full object-cover rounded-lg shadow-md border-2 border-white transition-transform duration-300 hover:scale-[3] origin-center"
                        />
                      </div>
                    ))
                  ) : (
                    <div className="w-24 h-24 opacity-0"></div> /* Placeholder to keep aligned */
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CONTACT FORM */}
        <div className="bg-white shadow-lg rounded-3xl p-8 md:p-12 border border-gray-100">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Get in Touch</h2>
            <p className="text-gray-500">Have a question or want to work together? Drop me a message.</p>
          </div>

          <iframe name="hidden_iframe" id="hidden_iframe" style={{ display: 'none' }} ref={iframeRef} onLoad={handleIframeLoad} title="hidden_iframe" />

          <form
            action="https://docs.google.com/forms/d/e/1FAIpQLSfEXyOdVtYoTZEl2SfBKp44tpsdmpN-_LaLCM_1ATLNbjp4xA/formResponse"
            method="post"
            target="hidden_iframe"
            onSubmit={handleSubmit}
            className="max-w-2xl mx-auto space-y-6"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">Name</label>
                <input
                  type="text"
                  id="name"
                  name="entry.2005620554"
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all bg-gray-50 focus:bg-white"
                  placeholder="Your Name"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                <input
                  type="email"
                  id="email"
                  name="entry.1045781291"
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all bg-gray-50 focus:bg-white"
                  placeholder="hello@example.com"
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">Message</label>
              <textarea
                id="message"
                name="entry.839337160"
                rows="5"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none bg-gray-50 focus:bg-white"
                placeholder="How can I help you?"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full py-4 px-6 rounded-xl shadow-lg text-lg font-bold text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 transform hover:-translate-y-0.5 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={submitted}
            >
              {submitted ? 'Sending...' : 'Send Message'}
            </button>
          </form>

          {/* Success Modal */}
          {showDialog && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm">
              <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full text-center animate-[fadeIn_0.3s_ease-out]">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
                  <svg className="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Message Sent!</h3>
                <p className="text-gray-500 mb-8">Thanks for reaching out! I'll get back to you shortly.</p>
                <button
                  onClick={handleCloseDialog}
                  className="w-full py-3 rounded-xl bg-gray-900 text-white font-bold hover:bg-gray-800 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default About;
